module.exports = __webpack_public_path__ + "static/media/pegaso_min.571a981b.jpg";